<app-view-title Title="{{ 'Intellitrailer.Rental.Component.ExtendRental.Extend' | translate : 'Extend' }}" [isSplitColor]="true"></app-view-title>
<view-content [centered]="true">
  @if(booking.ReturnTime) {
  <p>{{ 'Intellitrailer.Booking.ExtendBookingTimePicker.CurrentTime' | translate : 'Current time return'}} : {{ this.booking.ReturnTime.toDate() | date:'MMM dd, HH:mm' | uppercase }}</p>
  }
  <div class="row">
    <div class="col-12 col-md-6">
      <title-with-divider Title="{{'Intellitrailer.Booking.ExtendBookingTimePicker.ChoseNewTime' | translate : 'Choose new return time'}}"></title-with-divider>
      <mat-form-field>
        <mat-icon matPrefix (click)="setReturnDate(null, -1); $event.stopPropagation()" [ngClass]="isSameDay(this.returnDate, this.today.toDate()) ? 'unselectable' : 'selectable'">keyboard_arrow_left</mat-icon>
        <input #returnInput class="input-center" matInput [matDatepicker]="return" [(ngModel)]="returnDate" [min]="this.today.toDate()" (dateChange)="setReturnDate($event.value)" (focus)="return.open()">
        <mat-datepicker-toggle matSuffix [for]="return"></mat-datepicker-toggle>
        <mat-datepicker #return (closed)="returnInput.blur()"></mat-datepicker>
        <mat-icon matSuffix (click)="setReturnDate(null, 1); $event.stopPropagation()">keyboard_arrow_right</mat-icon>
      </mat-form-field>

      <timePicker #returnTime
                  [booking]="booking"
                  [minTime]="minReturn"
                  [maxTime]="maxReturn"
                  [selectedTime]="_returnTime"
                  [timeSlots]="returnSlots"
                  (selectedTimeChange)="setReturnTime($event)"
                  steps="quarter"
                  [loader]="timePickerLoading"
                  [isClosed]="returnClosed">
      </timePicker>

      @if(iniatingLoader){
      <div class="componentLoader">
        <mat-progress-spinner diameter="60" mode="indeterminate"></mat-progress-spinner>
      </div>
      }

    </div>
  </div>
  <p>{{ 'Intellitrailer.Booking.ExtendBookingTimePicker.NewTime' | translate : 'New time return'}} : {{ _returnTime.toDate() | date:'MMM dd, HH:mm' | uppercase}}</p>
  <p>
    <b>
      {{ 'Intellitrailer.Booking.ExtendBookingTimePicker.AdditionalCost' | translate : 'Additional Cost'}} :
      @if(!priceLoading) {
      {{ additionalCost | currency }}
      }
      @else { <div class="spinner-container">
              <mat-spinner diameter="20"></mat-spinner>
              </div>
    }
</b>
  </p>
  @if(loader) {
  <div class="spinner-container">
    <mat-progress-spinner diameter="75" mode="indeterminate"></mat-progress-spinner>
  </div>
  }
</view-content>
  <view-actions  mode="transparent">
    <button mat-raised-button color="primary" [disabled]="!extendButtonEnabled || booking.ReturnTime.toDate().toISOString() == _returnTime.toDate().toISOString() || priceLoading" (click)="extend()">{{ 'Intellitrailer.Rental.Component.ExtendRental.Extend' | translate : 'Extend' }}</button>
  </view-actions>
  
